<template>
  <div
    :class="{ is_mobile: !$tools.isPc() }"
    class="page_middle_container page_middle_project_detail poContractAudit_container"
  >
    <div class="page_middle_title">客户合同/po页面审核</div>
    <div class="page_middle_content">
      <div class="page_middle_body">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>客户名称：
            </div>
            <div class="page_middle_row_value">
              <el-input
                :disabled="true"
                v-model="data.customer_company"
                placeholder="客户名称"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>合同/po金额：
            </div>
            <div class="page_middle_row_value">
              <el-input disabled v-model="data.po_amount" placeholder="0.00">
                <template #suffix>
                  <el-tooltip
                    effect="dark"
                    :content="getChineseMoney"
                    placement="top-end"
                  >
                    <div>元(查看大写)</div>
                  </el-tooltip>
                </template>
              </el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">合同起始日期：</div>
            <div class="page_middle_row_value">
              <el-date-picker
                disabled
                v-model="data.start_time"
                value-format="YYYY-MM-DD"
                type="date"
                placeholder="请选择合同起始日期"
                size="small"
              />
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">合同终止日期：</div>
            <div class="page_middle_row_value">
              <el-date-picker
                disabled
                v-model="data.end_time"
                value-format="YYYY-MM-DD"
                type="date"
                placeholder="请选择合同终止日期"
                size="small"
              />
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>盖章文件份数：
            </div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model.number="data.documents_num"
                placeholder="请输入盖章文件份数"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span
              >是否需要邮寄原件：
            </div>
            <div class="page_middle_row_value">
              <el-radio-group v-model="data.need_original" disabled>
                <el-radio :label="1" size="small"> 是 </el-radio>
                <el-radio :label="0" size="small"> 否,电子版即可 </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="page_middle_row" v-if="data.need_original == 1">
          <div class="page_middle_row_td page_middle_row_td_textarea">
            <div class="page_middle_row_key">邮寄地址：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                type="textarea"
                v-model="data.mail_address"
                rows="2"
                placeholder="请输入邮寄地址"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td page_middle_row_td_textarea">
            <div class="page_middle_row_key">补充信息：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                type="textarea"
                v-model="data.supplementary_information"
                rows="3"
                :placeholder="`1、邮寄时间：\n2、邮寄要求：\n3、`"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">合同/po附件：</div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.po_contract_url">
                <div v-for="(item, index) in po_contract_url" :key="index" style="margin-bottom: 5px;">
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td page_middle_row_td_textarea">
            <div class="page_middle_row_key">其他相关材料：</div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.other_material_url">
                <div v-for="(item, index) in other_material_url" :key="index" style="margin-bottom: 5px;">
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
        <div v-if="data.examine_status == 0 && !query.isWatch">
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>审批结果：
              </div>
              <div class="page_middle_row_value">
                <el-select
                  v-model="auditData.examine_status"
                  placeholder="请选择审批结果"
                >
                  <el-option :value="1" label="通过"></el-option>
                  <el-option :value="2" label="驳回"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required" v-if="auditData.examine_status == 2">*</span>审批备注：
              </div>
              <div class="page_middle_row_value">
                <el-input
                  v-model.trim="auditData.examine_reason"
                  placeholder="请输入审批备注"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                审批结果：
              </div>
              <div class="page_middle_row_value" style="padding-left: 15px;display: flex;align-items: center;">
                  <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.examine_status == 1"><SuccessFilled /></el-icon>
                  <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.examine_status == 2"><CircleCloseFilled /></el-icon>
                  <span>
                      {{ $config.types.auditResult[data.examine_status] }}
                  </span>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                审批备注：
              </div>
              <div class="page_middle_row_value" style="padding-left: 15px;">
                {{ data.examine_reason }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="page_middle_buttongroup"
      v-if="data.examine_status == 0 && !query.isWatch"
    >
      <el-button type="primary" @click="doCommit" :loading="loading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
export default {
  name: "page_middle",
  components: {
      SuccessFilled, 
      CircleCloseFilled 
  },
  data() {
    return {
      auditData: {
        id: "",
        examine_status: "",
        examine_reason: "",
        operation_url: window.location.href,
      },
      data: {
        po_amount: "",
        start_time: "",
        end_time: "",
        documents_num: 0,
        need_original: 0,
        mail_address: "",
        supplementary_information: "",
        po_contract_url: "",
        other_material_url: "",
      },
      po_contract_url: [],
      other_material_url: [],
      loading: false,
    };
  },
  created() {
    this.query = { ...this.$route.query };
  },
  computed: {
    getChineseMoney() {
      let moneyText = this.$tools.numberToChinese(this.data.po_amount);
      return moneyText;
    },
  },
  mounted() {
    // if (this.item.id) {
    //   this.initData();
    //   return;
    // }
    this.initData();
  },
  methods: {
    initData() {
      let url = this.$tools.getURL(this.$urls.projectList.get_po_contract, {
        id: this.query.id,
      });
      this.$axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.auditData.id = res.data.id;
          this.po_contract_url = this.data.po_contract_url
            ? this.data.po_contract_url.split(",")
            : [];
          this.other_material_url = this.data.other_material_url
            ? this.data.other_material_url.split(",")
            : [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    verifyData() {
      if (!this.auditData.examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.auditData.examine_status == 2 &&
        !this.auditData.examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      this.loading = true;
      let url = this.$urls.projectList.po_audit;
      this.$axios
        .post(url, this.auditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });
          this.initData();
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>
<style>
.page_middle_project_detail .page_middle_row_value {
  display: flex;
  align-items: center;
}

.flex-column {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-justify-content-start {
  justify-content: start;
}

.zIndexBold {
  z-index: 1000;
  position: relative;
}

.is_mobile * {
  font-size: 1.25rem;
}

.is_mobile .page_middle_row {
  align-items: initial;
  flex-direction: column;
}

.is_mobile .page_middle_row .page_middle_row_td {
  margin-bottom: 10px;
}

.is_mobile .project_number_input {
  flex-direction: initial;
  align-items: center;
}

.is_mobile .page_middle_row_td_textarea .el-textarea {
  width: 60%;
}

.is_mobile .page_middle_row_key.page_middle_row_key_left {
  text-align: left;
  flex: 50px 0 0;
}
</style>
  